import React, { useState, useEffect } from "react";
import UploadFile from "./UploadFile";
import { Box, Grid } from "@mui/material";
import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import { completarRequisito } from "../services/expediente.service";
import { createUploadFile } from "../services/uploadFile.service";
import { notification } from "antd";
import Loader from "./Loader";

export default function RequisitoRespuestaArchivo({
  setIsVisibleModal,
  setReload,
  reload,
  id_expediente,
  requisito
}) {
  const [fileSelectedext, setFileSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const onClose = () => {
    setIsVisibleModal(false);
  };

  const saveAction = async (uploadedFiles) => {
    if(uploadedFiles!=null){
      try {
        setIsLoading(true);
        const data = {
            id_mov: requisito.id_mov,
            mov_respuesta_file_id: uploadedFiles.length > 0 ? uploadedFiles[0].fileId : null,
        };
        const result = await completarRequisito(data);
        setIsLoading(false);
        if (result.data) {
          setReload(!reload);
          onClose();
        }else{
         console.log("Error al completar requisito", result);
        }
      } catch (error) {
        console.log("Error al completar requisito", error);
      }
    }else{
      console.log("Archivo no seleccionado")
      notification["error"]({
        message: "Debe completar requisito subiendo el documento solicitado",
      });
    }

  };

  const addFiles = async () => {
    try {
      if (fileSelectedext.length > 0) {
        setIsLoading(true);
        const uploadResults = await Promise.all(
          fileSelectedext.map(async (file) => {
            const result = await createUploadFile(
              file.file,
              id_expediente,
              requisito.id_mov
            );

            if (result.status === 200) {
              return result;
            }
            return null;
          })
        );
        setIsLoading(false);
        saveAction(uploadResults);
      }
    } catch (error) {
      console.log("Failed to add selection", error);
    }
  };

  const handleCompleteSelection = async(selection) => {
    console.log("Archivo seleccionado", selection);
  }

  return (
    <>
        {isLoading ? (
            <Loader />
        ) : (
            <>
                <Grid item xs={12}>
                    <UploadFile
                        setFileSelected={setFileSelected}
                        fileSelectedext={fileSelectedext}
                        onCompleteFileSelection={handleCompleteSelection}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between">
                    <ButtonComponent
                        name="Guardar"
                        toAction={addFiles}
                    />
                    <div style={{ width: "5px" }}></div>
                    <ButtonComponent
                        name="Cancelar"
                        toAction={onClose}
                        color={COLORS.DANGER}
                    />
                    </Box>
                </Grid>  
            </>
        )}
    </>
  );
}
